import React from 'react';
import UiKitNotificationBanner, { NotificationBannerProps } from '@westwing/ui-kit/NotificationBanner';
import { BellaTestIds } from '../../../common/qaIds';

const NotificationBanner = (
    props: Omit<NotificationBannerProps, 'notificationDataTestId' | 'notificationDismissalButtonTestId'>
) => (
    <UiKitNotificationBanner
        {...props}
        notificationDataTestId={BellaTestIds.notificationBanner}
        notificationDismissalButtonTestId={BellaTestIds.notificationBannerDismissButton}
    />
);

export default NotificationBanner;
